import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Airborne sound insulation",
  description:
    "This principle section shows measurement results for airborne sound insulation parameters for measurement situations shown below.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      rowsSize: [3, 1],
      colSpan: {
        "0:0": 2,
      },
      gap: "0 5%",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/22/principle/principle-1.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<b>Volume of the receiving room:</b> 31.3 m<sup>2</sup><br>
                  <b>Net volume of the receiving room<br>(volume of the furniture subtracted):</b> 31.0 m<sup>3</sup><br>
                  <b>Surface of the wall:</b>  9.6 m<sup>2</sup>`,
                  scrollbars: false,
                  styles: {
                    fontSize: "12px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                justifyContent: "flex-end",
                paddingTop: "2%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "Measurement situation with source<br>positions in the transmitting room and<br>transmission paths through considered<br>wall of interest are shown.",
                  scrollbars: false,
                  styles: {
                    fontSize: "12px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                justifyContent: "flex-start",
                paddingTop: "2%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
